'use client';

import { useTranslations } from 'next-intl';
import { FAQ, type FAQItem } from '@/app/components/ui/FAQ';

export function QuestionSection() {
  const t = useTranslations('vidu-q3-vs-seedance-2-0-vs-kling-3-0');

  // 动态创建 FAQ 问题数据
  const faqItems: FAQItem[] = (['q1', 'q2', 'q3', 'q4', 'q5'] as const).map((key, index) => ({
    id: `faq-${index + 1}`,
    question: t(`faq.${key}.title`),
    answer: [{ title: t(`faq.${key}.description`) }],
  }));

  return (
    <section className="bg-black">
      <div className="mx-auto">
        <FAQ
          items={faqItems}
          defaultExpandedId="faq-1"
          title={t.rich('faq.title', {
            div: (chunks) => <div className="text-white">{chunks}</div>,
          })}
          customTopMargin="!mt-28"
          customBottomMargin="!mb-40"
        />
      </div>
    </section>
  );
}
